module.exports = __webpack_public_path__ + "static/media/Terrick Road Alcove Units (12).ad492c3e.jpg";